
    // Do not modify this file by hand!
    // Re-generate this file by running lit-localize

    import {html} from 'lit';
    import {str} from '@lit/localize';

    /* eslint-disable no-irregular-whitespace */
    /* eslint-disable @typescript-eslint/no-explicit-any */

    export const templates = {
      'h1fbdfea3ad6d664e': html`Acest lucru este adus de proiectul
                    <a href="${0}">Folksonomy Engine</a>. Nu ezitați
                    să participați sau să oferiți feedback.`,
'h5d824b4954e56ea5': html`Scan your <span class="everyday">everyday</span> <span class="foods">foods</span>`,
'h6bdd1b427aa985a4': html`Acest instrument vă permite să corectați lista de ingrediente. Puteți adăuga, elimina sau edita
                lista de ingrediente.
                <br>
                Acest caracter <span class="highlight">␣</span> reprezintă un spațiu.
                <br>
                Acest caracter <span class="highlight">↩︎</span> reprezintă o sfârșit de linie. `,
'hb28f1f2ec1744ee9': html`Aceste proprietăți sunt create și arhivate de utilizatori pentru orice fel de utilizări. Nu ezitați
                    să adăugați propriile proprietăți. Proprietățile și valorile pe care le creați
                    <strong>trebuie să fie factuale</strong>. Puteți consulta
                    <a href="${0}">lista de proprietăți deja utilizate de comunitate</a>
                    sau puteți explora documentația proprietăților
                    <a href="${1}">și motorul său de căutare</a>.`,
's000a5b76bd3a01c2': `Se încarcă proprietățile...`,
's000d98595e959c1e': `Disponibil pe Google Play`,
's013bdc8cf0d3583d': `Ajută-ne cu ingredientele`,
's01d2865e3e1d5501': `Thank you for your assistance!`,
's02ce7a2e7c1b020b': `Validați cultura`,
's03e9c8114521b998': `Voi edita ingredientele`,
's05ec315d9308091a': `Pictogramă colțuri cod de bare`,
's061eb5af92512c85': `Salvat! Poți ajuta cu încă una?`,
's06847c221c4c0bc1': `Aș dori să creez o proprietate pentru a [descrie cazul tău de utilizare]...`,
's06f6c6f99db6b552': `Original`,
's081e2ad82db71e1d': `Valori grupate`,
's09205907b5b56cda': `Nu`,
's0b4235aae602a950': `documentație dedicată`,
's0bb2d48532acc455': `Descărcați fișierul CSV`,
's0d5b7fee0311db68': `Proprietate`,
's0fb218abc2e157ed': `Invalidează imaginea`,
's100c4928cc74642a': `susține avansarea cercetării în sănătate publică.`,
's10db5498186c083b': `Anulează decuparea`,
's11a18a69b30b65ed': `Ajutați-ne să corectăm erorile din lista de ingrediente`,
's1205d5f6fccf8e69': `Valoarea proprietății`,
's15d64a0a6715285a': `Cheie nouă`,
's166bd56d19670a72': `Zoom`,
's19059bf0c4f7c162': `Zona de selecție`,
's1a52515ec8ddade8': `Product barcode`,
's1c5031113de500ce': `keeping our database open &amp; available to all,`,
's1dc4daf989c71284': `Ajutați-ne să corectăm informațiile nutriționale`,
's1e00019dc454872d': `Vă rugăm să furnizați un nume de proprietate folosind atributul property-name.`,
's1e49126af0935a5b': `Lista de produse care utilizează această proprietate`,
's21e73088de6f26f3': `Descărcați în App Store`,
's255857544a9d5ec0': `Reset`,
's25e94495991e95ba': `Thanks for your help! Can you assist with another question?`,
's2ceb11be2290bb1b': `Anulare`,
's2db7b654c0a9bde0': `Documentați proprietatea`,
's300b3a6ee4e1252d': str`Potrivire slabă ${0}%`,
's33f786bb6b4f0cf4': `Rezultatul culturilor`,
's33f85f24c0f5f008': `Salvează`,
's34be4af4e8fec4ae': `Întreabă mai întâi comunitatea`,
's36d86adc823cbfa6': `Înainte de a crea o proprietate nouă, discutați-o cu comunitatea:`,
's3781d25aa51a736c': `Documentația motorului de folcsonomie`,
's383ae4449428b61e': `Resetați decuparea`,
's39bcf88721a1e8ee': `Resetează selecția`,
's39e14e14300694c7': `Documentație și îndrumări`,
's3b430cfa5c1fe7f4': str`Documentație pentru ${0}`,
's3f4e4b52f230a892': `Pânză de imagine`,
's417b90913e05bc17': `Previzualizare`,
's41f7dca46d3f1b4a': `Valoare`,
's422bba9636ce2489': `Imagine centrală`,
's42dd66b2441566fd': `Pictogramă centrală`,
's43df2e8395f6834e': str`Please give to our ${0} Fundraiser`,
's453188ea728f64da': `Adăugați un nutrient`,
's453ab0dbb9b5c777': `Redimensionare la dreapta`,
's475b08749d0706ed': `Ajutați-ne să informăm milioane de consumatori din întreaga lume despre ceea ce mănâncă`,
's49730f3d5751a433': `Se încarcă...`,
's4bbc7472834a9686': `Your browser does not support barcode scanning.`,
's4d42cc7e00076a3b': `Număr de produse`,
's4df2f533c0c1e7d0': `Controale de imagine`,
's4e94adf723979402': `Open Food Facts needs your help with this product.`,
's4f4886341969d552': `Mută selecția`,
's4f751fb9b3ed766c': `Crearea unei proprietăți noi`,
's547c12ae169d00bc': `Disponibil pe F-Droid`,
's5560fb119e40923d': `Introduceți numele proprietății...`,
's55d7249883a98ca1': `despre această proprietate pe wiki-ul Open Food Facts`,
's565867d84c04aea2': `Proprietăți filtru...`,
's5666afe5cd0166de': `Vă rugăm să corectați erorile sau să modificați textul înainte de confirmare.`,
's57472465a23b41db': `Valori`,
's58e1eeea7a60ae51': `Se încarcă produsele...`,
's59df20feee978e5b': `Error: Invalid value.`,
's5c92c0051d44b6de': `Ajutați-ne să corectăm informațiile nutriționale.`,
's5dd6f12783fca34f': `Editați lista de ingrediente`,
's5e8250fb85d64c23': `Închidere`,
's5ed03bb1f3a15949': `Picture`,
's6306a31415aea913': `EU SUSȚIN`,
's6498dfe4855bb3a7': `unit`,
's64ef2a6c2dd1d3d1': `Modificare`,
's66413c24dcf680e2': `Omitere`,
's67ae6594857a4d57': `Vă mulțumim pentru contribuție!`,
's6cee7cad81dfedd1': `Imagine decupată`,
's6d7b6cdedaadfb6e': `Fiecare donație contează! Apreciem sprijinul acordat în promovarea unei transparențe alimentare sporite în lume.`,
's7124dde792a8faa2': `Android APK`,
's718dea04853f80ae': str`Potrivire bună ${0}%`,
's71a5c9f4b68ef4d4': `Numară`,
's74cb3d66f6a668e1': `Documentare`,
's787dd11bed0dc88a': `Redimensionare la stânga`,
's7ce4fd9430e80cea': `valoare`,
's801a05fa8e881f37': `Aflați mai multe despre crearea de proprietăți și instrucțiuni:`,
's8038273de2cf8b73': `Selectați o regiune pentru a o decupa.`,
's839cc2908a5387f2': `Filtrați codurile de bare...`,
's86197dcf3e96af64': `Răsfoiți și căutați proprietăți existente`,
's8a63be30a129a59c': `Redimensionează partea de jos`,
's8a8bfd67f2dd2810': `Download the OFF app with this QR code`,
's8af61807443f32a4': `Actions`,
's8b33c244759d7bd4': `Redimensionează dreapta sus`,
's8db84aa4bc949af2': `Documentați noua proprietate`,
's8f839a03997a16d7': `Vizualizare produs`,
's901ae1e236ac45d3': `Anulează ștergerea`,
's907f7a97c6b29425': `Rețineți că modelul de date poate fi modificat. Utilizați-l pe propriul risc.`,
's95d23d03f9147581': `Unzoom`,
's976dfd19ef58a1e1': `Click to scan a barcode and find out its details (health, preferences, etc.)`,
's98ff35f2a00dc60d': `Ingrediente:`,
's9a7f60fce090ecaf': `Nu s-au putut încărca proprietățile. Vă rugăm să încercați din nou mai târziu.`,
's9b87abd68fb9df45': `Nu a fost găsit? Creează o cheie nouă {value}`,
's9c0f52425fd2f07e': `Este posibil să nu se potrivească`,
's9fc41f789c63b40d': `Produse`,
'sa1fa766e0d5634d7': `Niciun scor disponibil`,
'sa548778b24054030': `Explorează toate proprietățile contribuite de proiectul Folksonomy Engine. Aceste proprietăți oferă metadate suplimentare și informații despre produsele din baza de date Open Food Facts.`,
'sa63907958bd0ec4b': `Redimensionează stânga sus`,
'sa95b4224f685a36a': `Închide fereastra modală`,
'sab56a1d439576fd6': `Pictogramă sugestie`,
'sac47ea2901d04c15': `Redimensionează stânga jos`,
'sb125227d436c2925': `Căutați conceptul proprietății dvs. în baza de date existentă cu proprietăți:`,
'sb125568d43642e6f': `Răspundeți la întrebări despre produs.`,
'sb1c538e038f9b214': str`Potrivire foarte bună ${0}%`,
'sb28639570ff3b852': `lista tuturor proprietăților`,
'sb3bdd638a58d30f4': `a implica o comunitate de cetățeni dedicați,`,
'sb3cbcc1bd0fff140': `După ce ați verificat că proprietatea dvs. nu există și comunitatea este de acord că este utilă, trebuie mai întâi să o documentați în wiki.`,
'sb3d4f79d9d8b71e5': `Trimite`,
'sb560fa37a7bfb6c2': `Nu s-au găsit produse pentru această proprietate.`,
'sb7f72e4c8a2d3357': `Filtrați valorile...`,
'sb8178320160f84ea': `Afișează decuparea`,
'sbad7d2734149470b': `Validați`,
'sbb623d6b18d966a0': `Nutrition facts are displayed on the packaging:`,
'sbd6be5cde472f37c': `Toate informațiile au primit răspuns! Mulțumesc pentru ajutor!`,
'sbd9a0b2293b3cd3c': `Cantitatea unei porții`,
'sbe472dc3c2685985': `Valoare corespunzătoare`,
'sc0520e1732a5c568': `Expand image`,
'sc0cc559e7ede852a': `Redimensionează partea de sus`,
'sc1c08d0cbcc3bd24': `Nu se potrivește`,
'sc52696641af72b53': `Instalează aplicația!`,
'sc5575e3107f87874': `Rotate image to the left`,
'sc57b630a7a70c61f': `Soluție sugerată`,
'sc681b137e8f604f7': `Confirmați ștergerea`,
'sc6daf8a31883f8b9': `Mută imaginea`,
'sc895972c88d38ca5': `Proprietatea folcsonomiei`,
'sca0c3305aff570b8': str`per specified serving "${0}"`,
'scace072bef961918': `Rânduri`,
'scb3b0671d7b7f640': `Valoare nouă`,
'scb489a1a173ac3f0': `Da`,
'scbab4bd737ba7934': str`group photo donation ${0}`,
'scd21019c3cd618f3': `Alătură-te discuției Slack`,
'scdb6cad0b92721bf': `Nu s-au găsit proprietăți.`,
'scf23a05631f93732': `Confirmare ștergere`,
'scfed2f270ef6a3aa': `Selectați zona`,
'sd1022bc1ef9204f7': `Imagine cu zoom`,
'sd1077c055cf9ba6b': `Ajutați-ne să validăm lista de ingrediente a produsului.`,
'sd698d21ddecba56b': `Salut! Ne poți ajuta să îmbunătățim informațiile despre produs răspunzând la următoarele întrebări:`,
'sd82bc2decefa621b': `să rămână independenți de industria alimentară,`,
'sdb97e5976482606e': `Verificați dacă o proprietate există deja`,
'sdbf806fefc584115': `Ar trebui să găsești un`,
'sdc673e73b5c13aea': `Ştergeţi`,
'sdc792b75f1edcaba': `Ajutați-ne să corectăm ortografia ingredientelor.`,
'sdca5deead576ceee': `Redimensionează dreapta jos`,
'sdcc2555c5dde524f': `Sigur doriți să ștergeți acest element? Această acțiune nu poate fi anulată.`,
'se206feec7ec57b28': `la 100g`,
'se419a9ab36987490': `Invalida`,
'se5127cf0f92e7e48': `Sfat: puteți găsi și`,
'se773f50d2a16d481': `Rotate image to the right`,
'sebb2c6c830a44574': `technical infrastructure (website/mobile app) &amp; a small permanent team`,
'sec6377f3c4e9b28c': `Voi propune o recoltă mai bună`,
'seea3800e27baa686': `Produse individuale`,
'sefaba4adc4ec9219': `Proprietăți de folcsonomie`,
'seffa8ca49175b5f0': `Proprietăți personalizate`,
'sf44a6b3b232c28ea': str`Înlocuiți valoarea curentă cu ${0}`,
'sf4cd86a2f5ef2588': `Cod de bare al produsului`,
'sf57a61152168cc81': `Ajutați-ne să corectăm detectarea ingredientelor`,
'sf88b90b8ba23871c': `Potrivire necunoscută`,
'sf9aee319a006c9b4': `Adaugă`,
'sfacbbe968fa7d773': `Numele proprietății:`,
'sfc40ea3d5d5aa6f8': `Donațiile dumneavoastră finanțează operațiunile zilnice ale asociației noastre non-profit:`,
'sfe87465d50530725': `Valoare corespunzătoare`,
's5f343a43e7ea9f91': `Error`,
'sd947a599045e9e0e': `Failed to check property conflicts. Please try again.`,
's92a0d19a28995530': `Success`,
's371091f240c17a7e': `Property renamed successfully!`,
's4603f58131a777bf': `Failed to rename property. Please try again.`,
's21694d2ab9c0bec5': `Property deleted successfully!`,
'scf78b75273a6b5fe': `Failed to delete property. Please try again.`,
's71ffcb25fc1c5356': `Rename this property`,
's60320a18282b2b33': `Rename`,
's6e2a82009cc3dfc7': `Delete this property`,
's8bccacf0fc176064': `Rename Property`,
's0df37909a355e56f': str`Rename property '${0}' to:`,
'sb550440eeb3f39c5': `New property name:`,
'sbb53591e587764b7': `Enter new property name...`,
's8acd49e96b4ee7d4': `Check Conflicts`,
'sd1cfdf0ef29cb6a5': `Property Rename Conflicts`,
'sf417737adaa5a8c2': str`Renaming '${0}' to '${1}' will affect:`,
's14571d0ac58a8b43': `Products with both properties:`,
'sb0d459e32656033f': `Products with old property only:`,
'sfa3027dde47305fe': `Products with new property only:`,
's9e5b8feb0892646e': `Do you want to proceed with the rename?`,
's97171907a2d1620b': `Proceed with Rename`,
's712d70fdcc3dd42b': `Delete Property`,
'sc11b78f2f3173f75': str`Are you sure you want to delete the property '${0}'?`,
's3b3fe4e829af3e8e': `This action cannot be undone.`,
's091d3d07b5b3076f': `OK`,
's72c9c4e6ab4ca7ae': `Value replaced successfully!`,
'sdd0eacd725bb2b1d': `Failed to replace value. Please try again.`,
'sfe87a7a8bed11acf': `Value deleted successfully!`,
'sccd2745bdd1087f6': `Failed to delete value. Please try again.`,
's88ece9a678e2f106': `Replace Value`,
's3355d65e22e222c9': str`Replace all instances of '${0}' with a new value:`,
's0d426d718d97d14e': `New value:`,
'se80a1ed3dcab7408': `Enter new value...`,
's2a8434b16dc214a3': `Replace`,
's8263352c7a634e7f': `Delete Value`,
'sebe99e3299746177': str`Are you sure you want to delete all instances of the value '${0}'?`,
's4b0b53abbd6af54a': `Replace this value across all products`,
'sb02836b5e3176cfe': `Delete this value from all products`,
    };
  